import GameModel from "../GameModel";
import Crew from "../model/crew/Crew";
import Vector from "../model/math/Vector";
import Projection from "../Projection";
import { Settings } from "../Settings";
import Fast from "../util/Fast";

export default class PanAnimation extends GameModel {
    /**
     * @param {Projection} projection 
     * @param {Crew} crew
     */
    constructor(projection, crew) {
        super();

        /**
         * @constant
         * @type {Projection}
         */
        this.projection = projection;

        /**
         * @constant
         * @type {Crew}
         */
        this.crew = crew;

        /**
         * @type {boolean}
         */
        this.animating = false;

        /**
         * @constant
         * @type {Vector}
         */
        this.workingCenter = new Vector(0, 0);

        /**
         * @constant
         * @type {number}
         */
        this.deltaThreshold = 1.5; // 1.5px is close enough

        /**
         * @constant
         * @type {number}
         */
        this.targetAnimationMillis = 200;
    }

    startAnimation() {
        if (this.animating) {
            return;
        }

        // calc x dist and y dist here
        this.crew.calculateCrewCenterCoordinate(this.workingCenter);
        /////const position = this.crew.main.position.worldCoordinateOrigin;

        // If we are just too far from the character, then just center there without animation.
        const distance = Fast.dist(this.workingCenter, this.projection.gridCenter);
        if (distance > Settings.grid.gridPixelWidth * 2) {
            this.projection.setGridCenter(this.workingCenter.x, this.workingCenter.y);
            this.projection.stayCenteredOnCharacter = true; 
            return;
        }

        const deltaX = this.workingCenter.x - this.projection.gridCenter.x;
        const deltaY = this.workingCenter.y - this.projection.gridCenter.y;

        if (deltaX === 0 && deltaY === 0) {
            this.animating = false;

            // Indiciate that the game should be keeping the player at the center of the screen.
            this.projection.stayCenteredOnCharacter = true; 

            return;
        }

        this.animating = true;
    }

    /**
     * @param {number} frameTimeRatio 
     * @returns {boolean} True if we were animating, but now we're done.
     */
    updateForFrame(frameTimeRatio) {
        if (!this.animating) {
            return false;
        }

        this.crew.calculateCrewCenterCoordinate(this.workingCenter);
        //////const position = this.crew.main.position.worldCoordinateOrigin;

        //const deltaX = position.x - this.projection.gridCenter.x;
        const deltaX = this.workingCenter.x - this.projection.gridCenter.x;
        const deltaY = this.workingCenter.y - this.projection.gridCenter.y;

        if (deltaX === 0 && deltaY === 0) {
            this.animating = false;
            return true;
        }

        const deltaXAbs = Math.abs(deltaX);
        const deltaYAbs = Math.abs(deltaY);

        // Calculate the motion for this frame.
        const xPerFrame = (deltaX / this.targetAnimationMillis) * Settings.time.defaultMillisPerFrame;
        const yPerFrame = (deltaY / this.targetAnimationMillis) * Settings.time.defaultMillisPerFrame;

        const xMotion = xPerFrame * frameTimeRatio;
        const yMotion = yPerFrame * frameTimeRatio;


        let newX;
        let newY;
        let doneX;
        let doneY;

        if (deltaXAbs < this.deltaThreshold || deltaXAbs < xMotion) {
            newX = this.workingCenter.x;
            doneX = true;
        }
        else {
            newX = this.projection.gridCenter.x + xMotion;
            doneX = false;
        }

        if (deltaYAbs < this.deltaThreshold || deltaYAbs < yMotion) {
            newY = this.workingCenter.y;
            doneY = true;
        }
        else {
            newY = this.projection.gridCenter.y + yMotion;
            doneY = false;
        }

        this.projection.setGridCenter(newX, newY);

        if (doneX && doneY) {

            // Indiciate that the game should be keeping the player at the center of the screen.
            this.projection.stayCenteredOnCharacter = true; 

            this.animating = false;
            return true;
        }

        return false;
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.animating = false;
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.resetFull();
    }

}